import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { LOGOS } from "../data/universities";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 rounded-xl bg-white p-1.5 flex items-center justify-center">
              <img src={LOGOS.europa} alt="Istituto Europa" className="w-full h-full object-contain" />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-extrabold text-white text-base">ECP Profili</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-white/60 font-semibold">Istituto Europa · Sassari</div>
            </div>
          </div>
          <p className="text-white/70 text-sm leading-relaxed">
            Centro ECP gestito dall'Istituto Europa – Fondazione Gianni e Mario Profili. Polo
            riconosciuto Pegaso, Mercatorum e San Raffaele.
          </p>
          <div className="mt-4 text-xs text-white/50 space-y-0.5">
            <div>P.IVA 02039840901 · C.F. 02039840901</div>
            <div>REA 206698 · Sassari</div>
          </div>
          <div className="flex gap-3 mt-5">
            <a
              href="https://www.instagram.com/istitutoeuropa_sassari"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-brand-emerald flex items-center justify-center transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href="https://www.facebook.com/istitutoeuropassassari"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 hover:bg-brand-emerald flex items-center justify-center transition-colors"
              data-testid="footer-facebook"
            >
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <div className="eyebrow text-brand-emerald mb-4">Navigazione</div>
          <ul className="space-y-2.5 text-sm text-white/80">
            <li><Link to="/universita" className="hover:text-white">Università</Link></li>
            <li><Link to="/corsi-di-laurea" className="hover:text-white">Corsi di Laurea</Link></li>
            <li><Link to="/master" className="hover:text-white">Master</Link></li>
            <li><Link to="/doppia-laurea" className="hover:text-white">Doppia Laurea</Link></li>
            <li><Link to="/eventi" className="hover:text-white">Eventi & Open Day</Link></li>
            <li><Link to="/orientamento" className="hover:text-white">Orientamento</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-brand-emerald mb-4">Contatti</div>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-brand-emerald" /> Via Forlanini 18, Sassari</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-emerald" />
              <a href="tel:+390792825126" className="hover:text-white">079 282 5126</a>
            </li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-emerald" />
              <a href="https://wa.me/393465726648" target="_blank" rel="noreferrer" className="hover:text-white">WhatsApp 346 572 6648</a>
            </li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-brand-emerald" />
              <a href="mailto:uni.telematica@istitutoeuropasassari.it" className="hover:text-white break-all">uni.telematica@istitutoeuropasassari.it</a>
            </li>
          </ul>
        </div>

        <div>
          <div className="eyebrow text-brand-emerald mb-4">Università</div>
          <ul className="space-y-2.5 text-sm text-white/80">
            <li>Università Telematica Pegaso</li>
            <li>Università Mercatorum</li>
            <li>Università San Raffaele Roma</li>
          </ul>
          <div className="mt-5">
            <Link to="/contatti" className="btn-primary text-sm" data-testid="footer-cta">
              Richiedi Info
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Istituto Europa – Fondazione Gianni e Mario Profili. Tutti i diritti riservati.</div>
          <div className="flex gap-5">
            <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/cookie-policy" className="hover:text-white">Cookie Policy</Link>
            <Link to="/gdpr" className="hover:text-white">GDPR</Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("ecp:open-cookie-preferences"))}
              className="hover:text-white"
              data-testid="footer-cookie-prefs"
            >
              Preferenze Cookie
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
